/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelvisionary3Inputs */



/**
* | output |
* | --- |
* | "The Futurist" |
*
* @param {Personalityarchetypelabelvisionary3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelvisionary3 = /** @type {((inputs?: Personalityarchetypelabelvisionary3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelvisionary3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Futurist")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Futurista")
	return /** @type {LocalizedString} */ ("Футурист")
});
export { personalityarchetypelabelvisionary3 as "personalityArchetypeLabelVisionary" }